<template>
  <div class="programacion-semanas-wrapper">
    <a-spin :spinning="loading">
      <div class="spin-content">
        <div class="marcaciones-app-container">
          <div class="marcaciones-card">
            <div class="header-marcaciones">
              <h2 class="titulo-marcaciones">
                <br>
                Control diario de marcaciones vs horario programado
              </h2>
            </div>
            <div class="header-row-marcaciones">
              <div class="header-left-marcaciones">
                <div class="filters-marcaciones">
                  <div class="field-group-marcaciones empleado-field-marcaciones">
                    <span class="field-label-marcaciones">Empleado</span>
                    <a-select
                      v-model="empleadoMarcacionesSeleccionado"
                      show-search
                      :filterOption="false"
                      placeholder="Buscar empleado..."
                      style="min-width: 260px"
                      @search="buscarEmpleados"
                      @change="onEmpleadoChange"
                      :notFoundContent="loadingEmpleados ? 'Buscando empleados...' : 'Sin resultados'"
                    >
                      <a-select-option
                        v-for="item in empleadosMarcacionesOptions"
                        :key="item.value"
                        :value="item.value"
                      >
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </div>

                  <div class="field-group-marcaciones">
                    <span class="field-label-marcaciones">Semana</span>
                    <a-date-picker
                      v-model="fechaSemanaMarcacionesMoment"
                      format="DD/MM/YYYY"
                      style="width: 100%"
                      @change="onFechaSemanaMarcacionesChange"
                      placeholder="Seleccionar semana"
                    />
                  </div>
                </div>

                <div class="week-nav-marcaciones">
                  <button
                    type="button"
                    class="btn-marcaciones btn-outline-marcaciones"
                    @click="irSemanaAnteriorMarcaciones"
                  >
                    <a-icon type="left" class="icon-marcaciones"/>
                    Semana anterior
                  </button>
                  <button
                    type="button"
                    class="btn-marcaciones btn-outline-marcaciones"
                    @click="irSemanaSiguienteMarcaciones"
                  >
                    Semana siguiente
                    <a-icon type="right" class="icon-marcaciones"/>
                  </button>
                </div>
              </div>

              <div class="header-actions-marcaciones">
                <div class="main-actions-marcaciones">
                  <button
                    v-if="$getConfigValue('MOSTRAR_BTN_RESUMEN_HIST_PROG_SEM', 'NO') === 'SI'"
                    type="button"
                    class="btn-marcaciones btn-ghost-marcaciones"
                    @click="irAResumenHistoricoMarcaciones"
                  >
                    <a-icon type="profile" class="icon-marcaciones"/>
                    Ver resumen histórico
                  </button>
                  <button
                    type="button"
                    class="btn-marcaciones btn-outline-marcaciones"
                    @click="exportarMarcacionesExcel"
                  >
                    <a-icon type="file-excel" class="icon-marcaciones"/>
                    Exportar a Excel
                  </button>
                  <button
                    type="button"
                    class="btn-marcaciones btn-primary-marcaciones"
                    @click="guardarMarcacionesSemana"
                  >
                    <a-icon type="save" class="icon-marcaciones"/>
                    Guardar ajustes
                  </button>
                </div>
              </div>
            </div>

            <div v-if="empleadoMarcacionesData" class="employee-info-marcaciones">
              <div class="employee-info-item-marcaciones">
                <span class="employee-info-label-marcaciones">Cargo:</span>
                <span class="employee-info-value-marcaciones">{{ empleadoMarcacionesData.cargo || 'N/A' }}</span>
              </div>
              <div class="employee-info-item-marcaciones">
                <span class="employee-info-label-marcaciones">Grupo:</span>
                <span
                  class="employee-info-value-marcaciones">{{ empleadoMarcacionesData.desc_id_h_att_1 || 'N/A' }}</span>
              </div>
              <div class="employee-info-item-marcaciones">
                <span class="employee-info-label-marcaciones">Puesto:</span>
                <span
                  class="employee-info-value-marcaciones">{{ empleadoMarcacionesData.desc_id_h_att_2 || 'N/A' }}</span>
              </div>
            </div>

            <div class="table-wrapper-marcaciones">
              <table>
                <thead>
                <tr>
                  <th>Día</th>
                  <th>Turno</th>
                  <th>T. Partido</th>
                  <th>Prog. entrada</th>
                  <th>Prog. salida</th>
                  <th>Real entrada</th>
                  <th>Real salida</th>
                  <th>Variación Ent|Sal</th>
                  <th>H. Lab/H. Prog.</th>
                  <th>Notas</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="dia in semanaMarcaciones" :key="dia.key">
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <div style="flex: 1;">
                        <div class="day-name-marcaciones">{{ dia.nombre }}</div>
                        <div class="day-sub-marcaciones">{{ dia.etiquetaFecha }}</div>
                      </div>
                      <a-button
                        v-if="puedeMostrarEliminar(dia)"
                        type="danger"
                        size="small"
                        icon="delete"
                        @click="eliminarTurno(dia)"
                        :loading="dia.eliminando"
                        style="flex-shrink: 0;"
                      >
                      </a-button>
                    </div>
                  </td>
                  <td>
                    <a-select
                      v-model="dia.turnoId"
                      style="min-width: 180px; width: 100%;"
                      @change="onTurnoChange(dia)"
                      :disabled="dia.turnoId && esTurnoNoVisible(dia.turnoId)"
                    >
                      <a-select-option
                        v-for="option in obtenerOpcionesTurnosParaDia(dia)"
                        :key="option.value"
                        :value="option.value"
                        :disabled="esTurnoDeshabilitado(dia, option.value)"
                      >
                        {{ option.label }}
                      </a-select-option>
                    </a-select>
                  </td>
                  <td>
                    <a-checkbox
                      v-model="dia.usarTurnoPartido"
                      @change="onTurnoPartidoChange(dia)"
                      :disabled="dia.turnoId && esTurnoNoVisible(dia.turnoId)"
                    >
                    </a-checkbox>
                  </td>
                  <td>
                    <div class="programacion-blocks-marcaciones">
                      <div class="programacion-block-marcaciones">
                        <input
                          class="input-time-marcaciones"
                          :class="{ 'input-enabled-marcaciones': puedeEditarProg(dia) || dia.usarTurnoPartido }"
                          type="time"
                          v-model="dia.progEntrada"
                          :disabled="!(puedeEditarProg(dia) || dia.usarTurnoPartido)"
                        />
                      </div>
                      <div
                        v-if="dia.usarTurnoPartido"
                        class="programacion-block-marcaciones programacion-partido-marcaciones"
                      >
                        <input
                          class="input-time-marcaciones input-enabled-marcaciones"
                          type="time"
                          v-model="dia.progEntradaPartido"
                          placeholder="Entrada partido"
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="programacion-blocks-marcaciones">
                      <div class="programacion-block-marcaciones">
                        <input
                          class="input-time-marcaciones"
                          :class="{ 'input-enabled-marcaciones': puedeEditarProg(dia) || dia.usarTurnoPartido }"
                          type="time"
                          v-model="dia.progSalida"
                          :disabled="!(puedeEditarProg(dia) || dia.usarTurnoPartido)"
                        />
                      </div>
                      <div
                        v-if="dia.usarTurnoPartido"
                        class="programacion-block-marcaciones programacion-partido-marcaciones"
                      >
                        <input
                          class="input-time-marcaciones input-enabled-marcaciones"
                          type="time"
                          v-model="dia.progSalidaPartido"
                          placeholder="Salida partido"
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="real-marcaciones-container">
                      <div
                        v-for="(marcacion, idx) in dia.realMarcaciones"
                        :key="idx"
                        class="real-marcacion-item"
                      >
                        <input
                          class="input-time-marcaciones"
                          type="time"
                          :value="marcacion.entrada"
                          disabled
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="real-marcaciones-container">
                      <div
                        v-for="(marcacion, idx) in dia.realMarcaciones"
                        :key="idx"
                        class="real-marcacion-item"
                      >
                        <input
                          class="input-time-marcaciones"
                          type="time"
                          :value="marcacion.salida"
                          disabled
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div
                      v-if="dia.tipo === 'descanso' || dia.realEntrada || dia.progEntrada"
                      class="pill-marcaciones"
                      :class="obtenerClaseVariacionEntrada(dia)"
                    >
                      <span class="pill-dot-marcaciones"></span>
                      {{ obtenerTextoVariacionEntrada(dia) }}
                    </div>
                  </td>
                  <td>
                    <div class="metric-hours-marcaciones">
                      {{ obtenerTextoHorasLaboradasDia(dia) }}
                    </div>
                  </td>
                  <td class="notes-cell-marcaciones">
                    <a-textarea
                      v-model="dia.notas"
                      :auto-size="{ minRows: 1, maxRows: 10 }"
                      placeholder="Notas"
                      class="textarea-notes-marcaciones"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>


            <div class="kpi-bar-marcaciones">
              <div class="kpi-group-marcaciones">
                <div class="kpi-item-marcaciones">
                  <span class="kpi-label-marcaciones">Horas trabajadas esta semana</span>
                  <span class="kpi-value-marcaciones">{{ horasTrabajadasSemanaMarcacionesTexto }}</span>
                </div>
                <div class="kpi-item-marcaciones">
                  <span class="kpi-label-marcaciones">Meta semanal (reforma laboral)</span>
                  <span class="kpi-value-marcaciones">{{ metaSemanalMarcacionesTexto }}</span>
                </div>
                <div class="kpi-item-marcaciones">
                  <span class="kpi-label-marcaciones">Diferencia</span>
                  <span class="kpi-value-marcaciones">{{ diferenciaSemanalMarcacionesTexto }}</span>
                  <span
                    class="kpi-tag-marcaciones"
                    :class="estadoKpiMarcacionesEsOk ? 'kpi-tag-ok-marcaciones' : 'kpi-tag-risk-marcaciones'"
                  >
                    <span class="dot-marcaciones"></span>
                    {{ estadoKpiMarcacionesEsOk ? 'Dentro de meta' : 'Por debajo de meta' }}
                  </span>
                </div>
              </div>

              <div class="progress-wrapper-marcaciones">
                <div class="progress-label-marcaciones">
                  <span>Avance frente a las {{ metaSemanalMarcacionesTexto }}</span>
                  <span>{{ porcentajeAvanceMarcacionesTexto }}</span>
                </div>
                <div class="progress-bar-marcaciones">
                  <div
                    class="progress-fill-marcaciones"
                    :style="{ width: porcentajeAvanceMarcaciones + '%' }"
                  ></div>
                  <div class="progress-marker-marcaciones"></div>
                </div>
                <div class="progress-marker-label-marcaciones">{{ metaSemanalMarcacionesTexto }}</div>
              </div>
            </div>

            <div class="footer-actions-marcaciones">
              <div class="legend-marcaciones">
                <span class="legend-title-marcaciones">Leyenda variación entrada y salida</span>
                <span class="legend-item-marcaciones">
                  <span class="status-dot-marcaciones status-on-time-marcaciones"></span>
                  Dentro de tolerancia
                </span>
                <span class="legend-item-marcaciones">
                  <span class="status-dot-marcaciones status-late-marcaciones"></span>
                  Tarde
                </span>
                <span class="legend-item-marcaciones">
                  <span class="status-dot-marcaciones status-early-marcaciones"></span>
                  Temprano
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import moment from 'moment'

  export default {
    name: 'ProgramacionSemanas',
    data () {
      return {
        loading: false,
        error: null,
        entradaUniversalSeleccionada: {},
        grupoPuestoSeleccionado: {},
        horaSeleccionada: null,
        tolerancia: parseInt(this.$getConfigValue('TOLERANCIA_PTS', 10), 10),
        turnosNoVisiblesRaw: this.$getConfigValue('TURNOS_NO_VISIBLES_PTS', '[DF, I, R, V, LR, LN, LM, IEG, PEG, AT, PAT, PR, CP, L, DS, MP]'),
        fechaInicio: null,
        fechaFin: null,
        empleados: [],
        columns: [],
        diasSemana: [],
        diasSemanaBase: [
          {key: 'dom', title: 'Dom', index: 0},
          {key: 'lun', title: 'Lun', index: 1},
          {key: 'mar', title: 'Mar', index: 2},
          {key: 'mie', title: 'Mié', index: 3},
          {key: 'jue', title: 'Jue', index: 4},
          {key: 'vie', title: 'Vie', index: 5},
          {key: 'sab', title: 'Sáb', index: 6}
        ],
        debounceTimers: {},
        limiteLegal: 44.00,
        limiteLegalHoras: '44 ha',
        limiteLegalDias: '44',
        empleadoMarcacionesSeleccionado: null,
        empleadosMarcacionesOptions: [],
        empleadoMarcacionesData: null,
        empleadosMarcacionesMap: {},
        fechaSemanaMarcaciones: moment().format('YYYY-MM-DD'),
        semanaMarcaciones: [],
        metaSemanalMarcaciones: parseInt(this.$getConfigValue('META_SEMANAL_PTS', 46), 10),
        shiftsOptions: [],
        shiftMap: {},
        loadingEmpleados: false
      }
    },
    mounted () {
      this.http = new HttpUtil()
      this.inicializarDiasSemana()
      this.inicializarColumnas()
      this.cargarEmpleados()
      this.cargarTurnosDisponibles()
      this.inicializarMarcacionesSemana(this.fechaSemanaMarcaciones)

      // Asegurar que el menú principal esté visible al ingresar a esta opción
      /*      this.$nextTick(() => {
              this.ensureMenuVisible()
            }) */
    },
    beforeDestroy () {
      // Limpiar todos los timers pendientes
      Object.values(this.debounceTimers).forEach(timer => clearTimeout(timer))
      if (this.empleadoSearchTimer) {
        clearTimeout(this.empleadoSearchTimer)
        this.empleadoSearchTimer = null
      }
    },
    beforeMount () {
      // Asegurar que el menú principal esté visible antes de montar el componente
      this.ensureMenuVisible()
    },
    computed: {
      metaSemanalMarcacionesTexto () {
        return this.formatearHorasConComa(this.metaSemanalMarcaciones || 0)
      },
      validarFormulario () {
        return !JsUtils.isEmpty(this.entradaUniversalSeleccionada) &&
          this.horaSeleccionada !== null &&
          this.fechaInicio !== null
      },
      empleadosMarcaciones () {
        return this.empleados
          .filter(emp => emp && emp.nombre && emp.nombre !== 'Límite Legal')
          .map(emp => ({
            id: emp.id_emp,
            nombre: emp.nombre
          }))
      },
      horasTrabajadasSemanaMarcaciones () {
        if (!Array.isArray(this.semanaMarcaciones)) return 0

        // Sumar las horas_trabajadas_dia de cada día (viene del backend)
        let totalHoras = 0
        this.semanaMarcaciones.forEach(dia => {
          if (dia.horasTrabajadasDia) {
            totalHoras += parseFloat(dia.horasTrabajadasDia) || 0
          }
        })
        return totalHoras
      },
      horasTrabajadasSemanaMarcacionesTexto () {
        return this.formatearHorasConComa(this.horasTrabajadasSemanaMarcaciones || 0)

        // return this.formatearHorasConComa(this.metaSemanalMarcaciones)
      },
      diferenciaSemanalMarcaciones () {
        return this.horasTrabajadasSemanaMarcaciones - this.metaSemanalMarcaciones
      },
      diferenciaSemanalMarcacionesTexto () {
        const diff = this.diferenciaSemanalMarcaciones
        const abs = Math.abs(diff)
        const textoAbs = this.formatearHorasConComa(abs)
        if (diff >= 0) {
          return textoAbs
        }
        return `-${textoAbs}`
      },
      porcentajeAvanceMarcaciones () {
        if (!this.metaSemanalMarcaciones) return 0
        const porcentaje = (this.horasTrabajadasSemanaMarcaciones / this.metaSemanalMarcaciones) * 100
        if (!isFinite(porcentaje)) return 0
        const redondeado = Math.round(porcentaje)
        if (redondeado < 0) return 0
        if (redondeado > 150) return 150
        return redondeado
      },
      porcentajeAvanceMarcacionesTexto () {
        return `~${this.porcentajeAvanceMarcaciones} %`
      },
      estadoKpiMarcacionesEsOk () {
        return this.diferenciaSemanalMarcaciones >= 0
      },
      tieneSeleccionEliminar () {
        if (!Array.isArray(this.semanaMarcaciones)) return false
        return this.semanaMarcaciones.some(d => d && d.id && d.seleccionadoEliminar === true)
      },
      turnosNoVisibles () {
        // Procesar turnosNoVisiblesRaw de string a array
        // Formato esperado: '[DF, I, R, V, ...]' o 'DF, I, R, V, ...'
        if (!this.turnosNoVisiblesRaw || typeof this.turnosNoVisiblesRaw !== 'string') {
          return []
        }
        const cleaned = this.turnosNoVisiblesRaw.trim()
          .replace(/^\[/, '')
          .replace(/\]$/, '')
          .trim()
        if (!cleaned) return []
        return cleaned.split(',')
          .map(t => t.trim().toUpperCase())
          .filter(t => t.length > 0)
      },
      fechaSemanaMarcacionesMoment: {
        get () {
          return this.fechaSemanaMarcaciones ? moment(this.fechaSemanaMarcaciones, 'YYYY-MM-DD') : null
        },
        set (val) {
          this.fechaSemanaMarcaciones = val ? val.format('YYYY-MM-DD') : ''
        }
      }
    },
    methods: {
      puedeMostrarEliminar (dia) {
        if (!dia || !dia.id || !dia.turnoId) return false

        const shift =
          this.shiftMap[String(dia.turnoId)] ||
          this.shiftMap[Number(dia.turnoId)]

        if (!shift || !shift.text) return true

        const textoTurno = shift.text.trim().toUpperCase()

        // NO mostrar si es turno no visible
        return !this.turnosNoVisibles.some(codigo => {
          const cod = codigo.trim().toUpperCase()
          return textoTurno === cod || textoTurno.startsWith(cod + ' ')
        })
      },
      ensureMenuVisible () {
        // Buscar el componente main que contiene el menú principal
        let parent = this.$parent
        let maxDepth = 10 // Limitar la búsqueda para evitar loops infinitos
        let depth = 0

        while (parent && depth < maxDepth) {
          // Verificar si este componente tiene la propiedad collapsed (componente main)
          if (parent.$data && typeof parent.$data.collapsed === 'boolean') {
            // Si la pantalla es mayor o igual a 992px (breakpoint lg de Ant Design), asegurar que el menú esté visible
            if (window.innerWidth >= 992) {
              parent.$data.collapsed = false
            }
            break
          }
          parent = parent.$parent
          depth++
        }
      },
      combineDateAndTime (dateStr, timeStr) {
        // Combina una fecha y hora en formato 'YYYY-MM-DD HH:mm:ss'
        return `${dateStr} ${timeStr}:00`
      },
      async buscarEmpleados (q) {
        // Busca empleados en el servidor con debounce (300ms) y llena las opciones de selección.
        if (this.empleadoSearchTimer) {
          clearTimeout(this.empleadoSearchTimer)
          this.empleadoSearchTimer = null
        }

        if (!q || q.length < 2) {
          this.empleadosMarcacionesOptions = []
          return
        }

        this.loadingEmpleados = true

        this.empleadoSearchTimer = setTimeout(async () => {
          try {
            const response = await this.http.getInstance().get(
              'empleados/lookup',
              {
                params: {
                  ddquery: q,
                  estado: 'N'
                }
              }
            )

            const rows =
              response &&
              response.data &&
              Array.isArray(response.data.data)
                ? response.data.data
                : []

            this.empleadosMarcacionesOptions = rows.map(emp => {
              const empId = String(emp.id_emp)
              // Store full employee data in map for later retrieval
              this.empleadosMarcacionesMap[empId] = emp
              return {
                label: `${emp.id_person} - ${emp.nombre}`,
                value: empId
              }
            })
          } catch (e) {
            this.empleadosMarcacionesOptions = []
          } finally {
            this.loadingEmpleados = false
            this.empleadoSearchTimer = null
          }
        }, 300)
      },
      onEmpleadoChange () {
        // Store full employee data when selected
        if (this.empleadoMarcacionesSeleccionado) {
          this.empleadoMarcacionesData = this.empleadosMarcacionesMap[String(this.empleadoMarcacionesSeleccionado)] || null
        } else {
          this.empleadoMarcacionesData = null
        }
        // Al cambiar el empleado seleccionado y existir fecha, carga las marcaciones de la semana
        if (this.empleadoMarcacionesSeleccionado && this.fechaSemanaMarcaciones) {
          this.cargarMarcacionesSemana()
        }
      },
      calculateHours (startTime, endTime) {
        // Calcula las horas trabajadas entre dos tiempos, manejando cruces de medianoche y formateando a 2 decimales.
        if (!startTime || !endTime) return '0.00'

        const [startHour, startMinute] = startTime.split(':').map(Number)
        const [endHour, endMinute] = endTime.split(':').map(Number)

        // Convertir a minutos para un cálculo más fácil
        const startMinutes = startHour * 60 + startMinute
        let endMinutes = endHour * 60 + endMinute

        // Si la hora de finalización es anterior a la hora de inicio, el turno pasa la medianoche
        // Sumar 24 horas (1440 minutos) a la hora de finalización.
        if (endMinutes <= startMinutes) {
          endMinutes += 1440
        }

        const totalMinutes = endMinutes - startMinutes
        const totalHours = totalMinutes / 60

        // Formato a 2 decimales
        return totalHours.toFixed(2)
      },
      getWeekEndDate (startDate) {
        // Usar el moment para inicializarMarcacionesSemana
        // Calcular el lunes de la semana que contiene la fecha de inicio y sumar 6 días para obtener el domingo
        const base = moment(startDate, 'YYYY-MM-DD')
        const lunes = base.clone().isoWeekday(1) // Obtenga el lunes de la semana
        const domingo = lunes.clone().add(6, 'days') // Añade 6 días para obtener el domingo
        return domingo.format('YYYY-MM-DD')
      },
      getWeekStartDate (startDate) {
        // Usar el moment para inicializarMarcacionesSemana
        // Calcular el lunes de la semana que contiene startDate
        const base = moment(startDate, 'YYYY-MM-DD')
        const lunes = base.clone().isoWeekday(1) // Obtenga el lunes de la semana
        return lunes.format('YYYY-MM-DD')
      },
      inicializarDiasSemana () {
        // Construye la lista de días de la semana desde una fecha inicial, asignando títulos y fechas formateadas.
        // Si no hay fecha de inicio, usar lunes a sábado por defecto
        if (!this.fechaInicio) {
          this.diasSemana = this.diasSemanaBase.slice(1, 7).map(dia => ({
            key: dia.key,
            title: dia.title,
            dataIndex: dia.key,
            fecha: null
          }))
          return
        }

        const fechaInicioMoment = moment(this.fechaInicio)
        const diaSemanaInicio = fechaInicioMoment.day() // 0=domingo, 1=lunes, etc.

        this.diasSemana = []
        for (let i = 0; i < 7; i++) {
          const diaIndex = (diaSemanaInicio + i) % 7
          const diaBase = this.diasSemanaBase.find(d => d.index === diaIndex)
          const fechaDia = fechaInicioMoment.clone().add(i, 'days')

          this.diasSemana.push({
            key: diaBase.key,
            title: `${diaBase.title}`,
            subtitle: fechaDia.format('DD/MM'),
            dataIndex: diaBase.key,
            fecha: fechaDia.format('YYYY-MM-DD')
          })
        }
      },
      inicializarColumnas () {
        // Inicializa las columnas de la tabla: empleado, días de la semana y columna de total.
        this.columns = [
          {
            title: 'Empresa/Empleado',
            dataIndex: 'nombre',
            key: 'nombre',
            fixed: 'left',
            width: 200,
            scopedSlots: {customRender: 'nombreRenderer'}
          }
        ]

        // Agregar columnas para cada día de la semana con subtítulo
        this.diasSemana.forEach(dia => {
          this.columns.push({
            title: `${dia.title}${dia.subtitle ? ' ' + dia.subtitle : ''}`,
            children: [{
              title: 'Hora Programada de Ingreso',
              dataIndex: dia.dataIndex,
              key: dia.key,
              width: 220,
              align: 'center',
              scopedSlots: {customRender: `${dia.key}Slot`}
            }]
          })
        })

        // Columna de Total
        this.columns.push({
          title: 'Total',
          dataIndex: 'total',
          key: 'total',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'totalRenderer'}
        })
      },
      cargarEmpleados () {
        // Los datos se cargarán solo cuando se seleccione un empleado
        // No se cargan automáticamente al entrar a la opción
        // Inicializar array vacío
        this.empleados = []
      },
      procesarHorarios (horarios) {
        // Procesa los horarios recibidos del backend, mapeándolos a los días de la semana y actualizando marcaciones y turnos.
        // Reiniciar la semana
        this.inicializarMarcacionesSemana(this.fechaSemanaMarcaciones)

        if (!horarios || !horarios.length) return

        // Agrupar horarios por fecha para manejar turnos partidos
        const horariosPorFecha = {}

        horarios.forEach(horario => {
          let fecha = null
          if (horario.fecha) {
            fecha = horario.fecha
          } else if (horario.start_time) {
            fecha = horario.start_time.split(' ')[0]
          }
          if (fecha) {
            if (!horariosPorFecha[fecha]) {
              horariosPorFecha[fecha] = []
            }
            horariosPorFecha[fecha].push(horario)
          }
        })

        // Procesar cada fecha
        Object.keys(horariosPorFecha).forEach(fecha => {
          const horariosDia = horariosPorFecha[fecha]

          // Encontrar el horario principal (el que tiene start_time y final_time principales)
          // Los turnos partidos ahora vienen en el mismo registro con start_date_shift_match y end_date_shift_match
          let horarioPrincipal = horariosDia.find(h => h.start_time && h.final_time && !h.start_date_shift_match) || horariosDia[0]

          // Si no hay horario principal explícito, usar el primero que tenga start_time
          if (!horarioPrincipal && horariosDia.length > 0) {
            horarioPrincipal = horariosDia.find(h => h.start_time) || horariosDia[0]
          }

          // Procesar horario principal (los datos de turno partido vienen en el mismo objeto)
          if (horarioPrincipal) {
            this.procesarHorarioIndividual(horarioPrincipal, fecha, null)
          }
        })
      },
      procesarHorarioIndividual (horario, fecha, horarioPartido) {
        // Extrae la parte de la fecha del timestamp
        let startTime = ''
        let endTime = ''

        if (horario.start_time) {
          const timePart = horario.start_time.split(' ')[1]
          if (timePart) {
            startTime = timePart.substring(0, 5) // Obtiene HH:MM
          }
        }

        if (horario.final_time) {
          const timePart = horario.final_time.split(' ')[1]
          if (timePart) {
            endTime = timePart.substring(0, 5) // Obtiene HH:MM
          }
        }

        // Convertir "24:00" a "00:00" para compatibilidad con inputs de tipo time
        // Los inputs HTML time no aceptan "24:00", solo "00:00" a "23:59"
        if (endTime === '24:00') {
          endTime = '00:00'
        }

        const diaIndex = this.semanaMarcaciones.findIndex(
          d => d.fecha === fecha
        )

        if (diaIndex !== -1) {
          // Formatear las horas de entrada y salida real
          // Conservar la información completa de fecha y hora si está disponible para realizar cálculos más precisos
          let realEntrada = ''
          let realSalida = ''
          let realEntradaDateTime = null
          let realSalidaDateTime = null

          if (horario.real_in) {
            const realInStr = String(horario.real_in)
            if (realInStr.length >= 16) {
              realEntrada = realInStr.substring(11, 16)
              try {
                realEntradaDateTime = moment(realInStr.substring(0, 16), 'YYYY-MM-DD HH:mm')
              } catch (e) {
              }
            } else if (realInStr.includes(':')) {
              realEntrada = realInStr.substring(0, 5)
            }
          }
          if (horario.real_out) {
            const realOutStr = String(horario.real_out)
            if (realOutStr.length >= 16) {
              realSalida = realOutStr.substring(11, 16)
              try {
                realSalidaDateTime = moment(realOutStr.substring(0, 16), 'YYYY-MM-DD HH:mm')
              } catch (e) {
              }
            } else if (realOutStr.includes(':')) {
              realSalida = realOutStr.substring(0, 5)
            }
          }

          // Convertir turnoId a string para consistencia
          const turnoIdStr = horario.id_rh_t_shifts_setup ? String(horario.id_rh_t_shifts_setup) : null

          // Actualizar shiftMap con información del backend si está disponible
          if (turnoIdStr) {
            const existingShift = this.shiftMap[turnoIdStr] || this.shiftMap[Number(turnoIdStr)]

            // Si ya existe en shiftMap, mantener su información (especialmente el 'text')
            // Solo actualizar si no existe o si hay información nueva del backend
            if (existingShift) {
              // Mantener la información existente, especialmente el 'text' que es el identificador correcto
              // No sobrescribir con datos del backend que pueden no tener el 'text'
            } else if (horario.id_shift) {
              // Si no existe, crear nueva entrada (aunque idealmente debería existir de cargarTurnosDisponibles)
              const textUpper = (horario.id_shift || '').trim().toUpperCase()
              const isUniversal = textUpper.startsWith('U ') || textUpper === 'U'

              const shiftInfo = {
                id_shift: horario.id_shift,
                value: horario.id_shift,
                text: horario.id_shift, // Fallback si no hay text disponible
                allow_edit: isUniversal
              }

              // Guardar tanto con clave string como numérica para facilitar la búsqueda
              this.shiftMap[turnoIdStr] = shiftInfo
              const turnoIdNum = Number(turnoIdStr)
              if (!isNaN(turnoIdNum)) {
                this.shiftMap[turnoIdNum] = shiftInfo
              }
            }
          }

          // Extraer datos del turno partido si existe
          let usarTurnoPartido = false
          let progEntradaPartido = ''
          let progSalidaPartido = ''

          // Priorizar los campos start_date_shift_match y end_date_shift_match del backend
          if (horario.start_date_shift_match && horario.end_date_shift_match) {
            usarTurnoPartido = true
            try {
              const startPartido = moment(horario.start_date_shift_match)
              const endPartido = moment(horario.end_date_shift_match)
              progEntradaPartido = startPartido.format('HH:mm')
              progSalidaPartido = endPartido.format('HH:mm')
            } catch (e) {
              // Si falla el parsing, intentar extraer de string
              const startStr = String(horario.start_date_shift_match)
              const endStr = String(horario.end_date_shift_match)
              if (startStr.length >= 16) {
                progEntradaPartido = startStr.substring(11, 16)
              }
              if (endStr.length >= 16) {
                progSalidaPartido = endStr.substring(11, 16)
              }
            }
          } else if (horarioPartido) {
            usarTurnoPartido = true
            if (horarioPartido.start_time) {
              const timePart = horarioPartido.start_time.split(' ')[1]
              if (timePart) {
                progEntradaPartido = timePart.substring(0, 5)
              }
            }
            if (horarioPartido.final_time) {
              const timePart = horarioPartido.final_time.split(' ')[1]
              if (timePart) {
                progSalidaPartido = timePart.substring(0, 5)
              }
            }
          } else if (horario.usar_turno_partido || horario.prog_entrada_partido) {
            usarTurnoPartido = true
            progEntradaPartido = horario.prog_entrada_partido || ''
            progSalidaPartido = horario.prog_salida_partido || ''
          }

          // Inicializar realMarcaciones si no existe (se cargarán después desde el API)
          // Asegurar que siempre haya al menos una casilla vacía
          if (!this.semanaMarcaciones[diaIndex].realMarcaciones || this.semanaMarcaciones[diaIndex].realMarcaciones.length === 0) {
            this.semanaMarcaciones[diaIndex].realMarcaciones = [{
              entrada: '',
              salida: '',
              entradaDateTime: null,
              salidaDateTime: null
            }]
          }

          this.semanaMarcaciones[diaIndex] = {
            ...this.semanaMarcaciones[diaIndex],
            id: horario.id || null,
            progEntrada: startTime,
            progSalida: endTime,
            status: horario.status || 'LIQ',
            notas: horario.comments || '',
            turnoId: turnoIdStr,
            realEntrada: realEntrada,
            realSalida: realSalida,
            realEntradaDateTime: realEntradaDateTime,
            realSalidaDateTime: realSalidaDateTime,
            realPairsCount: horario.real_pairs_count || 0,
            horasTrabajadasDia: horario.horas_trabajadas_dia || 0,
            usarTurnoPartido: usarTurnoPartido,
            progEntradaPartido: progEntradaPartido,
            progSalidaPartido: progSalidaPartido,
            seleccionadoEliminar: this.semanaMarcaciones[diaIndex].seleccionadoEliminar || false
          }
        }
      },
      fechaInicioCambiada (fecha) {
        if (fecha) {
          // Calcular fecha fin (6 días después para una semana completa)
          this.fechaFin = moment(fecha).add(6, 'days').format('YYYY-MM-DD')

          // Recalcular días de la semana basados en la nueva fecha
          this.inicializarDiasSemana()

          // Reinicializar columnas con los nuevos días
          this.inicializarColumnas()

          // Reinicializar horarios de empleados para los nuevos días
          this.empleados.forEach(emp => {
            const nuevosHorarios = {}
            this.diasSemana.forEach(dia => {
              // Mantener horarios existentes si existen, sino crear vacío
              nuevosHorarios[dia.key] = emp.horarios[dia.key] || [{
                entrada: null,
                salida: null,
                estado: null,
                guardando: false,
                guardado: false
              }]
            })
            emp.horarios = nuevosHorarios
          })

          this.$forceUpdate()
        } else {
          this.fechaFin = null
        }
      },
      filtrarEmpleados () {
        if (!this.fechaInicio) return

        this.loading = true
        const params = {
          fecha_inicio: this.fechaInicio,
          fecha_fin: this.fechaFin
        }

        if (!JsUtils.isEmpty(this.entradaUniversalSeleccionada)) {
          params.entrada_universal = this.entradaUniversalSeleccionada.value
        }

        if (!JsUtils.isEmpty(this.grupoPuestoSeleccionado)) {
          params.grupo_puesto = this.grupoPuestoSeleccionado.value
        }

        this.cargarEmpleados()
      },
      aplicarATodos () {
        if (!this.validarFormulario) {
          Mensajes.warning('Advertencia', 'Por favor complete todos los campos requeridos.')
          return
        }

        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea aplicar esta configuración a todos los empleados?',
          okText: 'Sí',
          okType: 'primary',
          cancelText: 'No',
          onOk: () => {
            this.loading = true

            // Aplicar la hora seleccionada a todos los empleados en todos los días
            this.empleados.forEach(empleado => {
              if (empleado.nombre !== 'Límite Legal') {
                this.diasSemana.forEach(dia => {
                  if (this.horaSeleccionada) {
                    // Reemplazar con un solo turno con la hora seleccionada
                    empleado.horarios[dia.key] = [{
                      entrada: this.horaSeleccionada.clone(),
                      salida: null,
                      estado: null
                    }]
                  }
                })
              }
            })

            // Guardar en el backend
            this.guardarProgramacion()
          }
        })
      },
      agregarTurno (record, dia) {
        record.horarios[dia].push({
          entrada: null,
          salida: null,
          estado: null,
          guardando: false,
          guardado: false
        })
        this.$forceUpdate()
      },
      onHorarioChange (record, dia, turnoIndex) {
        // Validar horario primero
        this.validarHorario(record, dia, turnoIndex)

        // Guardar automáticamente con debounce
        this.guardarHorarioConDebounce(record, dia, turnoIndex)
      },
      validarHorario (record, dia, turnoIndex) {
        const turno = record.horarios[dia][turnoIndex]

        if (turno.entrada && this.horaSeleccionada) {
          const diferencia = turno.entrada.diff(this.horaSeleccionada, 'minutes')

          if (diferencia > this.tolerancia && diferencia <= 420) {
            turno.estado = 'tarde'
          } else if (diferencia > 420) {
            turno.estado = 'mas_7_horas'
          } else {
            turno.estado = null
          }
        } else {
          turno.estado = null
        }

        this.$forceUpdate()
      },
      guardarHorarioConDebounce (record, dia, turnoIndex) {
        const turno = record.horarios[dia][turnoIndex]
        const key = `${record.id_emp}_${dia}_${turnoIndex}`

        // Limpiar timer anterior si existe
        if (this.debounceTimers[key]) {
          clearTimeout(this.debounceTimers[key])
        }

        // Marcar como guardando
        turno.guardando = true
        turno.guardado = false
        this.$forceUpdate()

        // Crear nuevo timer con debounce de 1.5 segundos
        this.debounceTimers[key] = setTimeout(() => {
          this.guardarHorarioIndividual(record, dia, turnoIndex)
        }, 1500)
      },
      guardarHorarioIndividual (record, dia, turnoIndex) {
        const turno = record.horarios[dia][turnoIndex]

        // Si no hay entrada ni salida, no guardar
        if (!turno.entrada && !turno.salida) {
          turno.guardando = false
          this.$forceUpdate()
          return
        }

        // eslint-disable-next-line no-unused-vars
        const datos = {
          id_emp: record.id_emp,
          // fecha: this.diasSemana.find(d => d.key === dia)?.fecha,
          fecha: (this.diasSemana.find(d => d.key === dia) || {}).fecha,
          dia: dia,
          turno_index: turnoIndex,
          entrada: turno.entrada ? turno.entrada.format('HH:mm') : null,
          salida: turno.salida ? turno.salida.format('HH:mm') : null
        }

        // Simular guardado (descomentar para usar backend real)
        setTimeout(() => {
          turno.guardando = false
          turno.guardado = true
          this.$forceUpdate()

          // Ocultar check después de 2 segundos
          setTimeout(() => {
            turno.guardado = false
            this.$forceUpdate()
          }, 2000)
        }, 500)
      },
      calcularTotalHoras (record) {
        let totalMinutos = 0

        this.diasSemana.forEach(dia => {
          const turnos = record.horarios[dia.key]
          if (turnos && Array.isArray(turnos)) {
            turnos.forEach(turno => {
              if (turno.entrada && turno.salida) {
                const diff = turno.salida.diff(turno.entrada, 'minutes')
                if (diff > 0) totalMinutos += diff
              } else if (turno.entrada) {
                totalMinutos += 8 * 60
              }
            })
          }
        })

        const horas = Math.floor(totalMinutos / 60)
        const minutos = totalMinutos % 60

        return `${horas}:${minutos.toString().padStart(2, '0')}`
      },
      guardarProgramacion () {
        const datos = {
          fecha_inicio: this.fechaInicio,
          fecha_fin: this.fechaFin,
          entrada_universal: this.entradaUniversalSeleccionada.value,
          hora_entrada: this.horaSeleccionada ? this.horaSeleccionada.format('HH:mm') : null,
          tolerancia: this.tolerancia,
          empleados: this.empleados.map(emp => ({
            id_emp: emp.id_emp,
            horarios: this.serializarHorarios(emp.horarios)
          }))
        }

        this.http.getInstance().post('programacion_semanal/guardar', datos)
          .then((response) => {
            Mensajes.success('Correcto', 'Programación guardada exitosamente.')
            this.cargarEmpleados()
          })
          .catch((error) => {
            const errorMessage = this.$getErrorMessage(error, 'No fue posible guardar la programación.')
            Mensajes.error('Error', errorMessage)
          })
          .finally(() => {
            this.loading = false
          })
      },
      serializarHorarios (horarios) {
        const serializado = {}
        this.diasSemana.forEach(dia => {
          const turnos = horarios[dia.key]
          if (turnos && Array.isArray(turnos)) {
            serializado[dia.key] = turnos.map(turno => ({
              entrada: turno.entrada ? turno.entrada.format('HH:mm') : null,
              salida: turno.salida ? turno.salida.format('HH:mm') : null
            }))
          }
        })
        return serializado
      },
      inicializarMarcacionesSemana (fechaBase) {
        const base = fechaBase ? moment(fechaBase, 'YYYY-MM-DD') : moment()
        const lunes = base.clone().isoWeekday(1)
        const nombres = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']
        const keys = ['lun', 'mar', 'mie', 'jue', 'vie', 'sab', 'dom']

        this.semanaMarcaciones = []
        for (let i = 0; i < 7; i++) {
          const fecha = lunes.clone().add(i, 'days')
          this.semanaMarcaciones.push({
            key: keys[i],
            nombre: nombres[i],
            fecha: fecha.format('YYYY-MM-DD'),
            etiquetaFecha: fecha.format('D MMM'),
            progEntrada: '',
            progSalida: '',
            realEntrada: '',
            realSalida: '',
            realMarcaciones: [{
              entrada: '',
              salida: '',
              entradaDateTime: null,
              salidaDateTime: null
            }],
            notas: '',
            tipo: '',
            turnoId: null,
            realPairsCount: 0,
            horasTrabajadasDia: 0,
            usarTurnoPartido: false,
            progEntradaPartido: '',
            progSalidaPartido: '',
            seleccionadoEliminar: false
          })
        }
      },
      async cargarTurnosDisponibles () {
        try {
          const {data} = await this.http.getInstance().get('shift_setup/dropdown', {
            params: {
              status: 1,
              pageSize: 600
            }
          })
          const rows = (data && (data.data || data.rows)) || []
          this.shiftMap = {}
          this.shiftsOptions = rows.map(r => {
            // Guardar información completa del turno en shiftMap
            // Usar el campo 'text' para identificar turnos Universales (ej: "U UNIVERSAL")
            const textUpper = (r.text || '').trim().toUpperCase()
            const isUniversal = textUpper.startsWith('U ') || textUpper === 'U'

            const shiftInfo = {
              id_shift: r.value || r.id_shift || '',
              value: r.value,
              text: r.text,
              allow_edit: isUniversal,
              start_time: r.start_time || null,
              end_time: r.end_time || null
            }

            // Guardar tanto con clave numérica como string para facilitar la búsqueda
            this.shiftMap[r.id] = shiftInfo
            this.shiftMap[String(r.id)] = shiftInfo

            return {
              label: r.text,   // lo que se muestra en el select
              value: String(r.id) // el identificador (convertido a string para consistencia)
            }
          })
        } catch (e) {
          // noop
        }
      },
      esUniversal (dia) {
        if (!dia || !dia.turnoId) return false

        // Convertir turnoId a string y también probar como número para compatibilidad
        const turnoIdStr = String(dia.turnoId)
        const turnoIdNum = Number(dia.turnoId)

        // Buscar en shiftMap usando string o número como clave
        let s = this.shiftMap[turnoIdStr]
        if (!s && !isNaN(turnoIdNum)) {
          s = this.shiftMap[turnoIdNum]
        }

        if (!s) return false

        // Usar el campo 'text' para identificar turnos Universales
        // El text puede ser "U UNIVERSAL" o similar
        const text = s.text || ''
        if (!text || typeof text !== 'string') return false

        const textUpper = text.trim().toUpperCase()
        // Verificar si empieza con "U " o es exactamente "U"
        return textUpper.startsWith('U ') || textUpper === 'U'
      },
      tieneIncapacidad (dia) {
        if (!dia || !dia.turnoId) return false

        // Convertir turnoId a string y también probar como número para compatibilidad
        const turnoIdStr = String(dia.turnoId)
        const turnoIdNum = Number(dia.turnoId)

        // Buscar en shiftMap usando string o número como clave
        let s = this.shiftMap[turnoIdStr]
        if (!s && !isNaN(turnoIdNum)) {
          s = this.shiftMap[turnoIdNum]
        }

        if (!s) return false

        // Usar el campo 'text' para identificar incapacidades
        const text = s.text || ''
        if (!text || typeof text !== 'string') return false

        const textUpper = text.trim().toUpperCase()
        // Verificar si contiene "INC" o "INCAP" en el texto
        return /(^INC|INCAP)/i.test(textUpper)
      },
      esTurnoNoVisible (turnoId) {
        // Verificar si un turno está en la lista de no visibles
        // Compara si el campo 'text' del turno contiene alguno de los códigos de turnosNoVisibles
        if (!turnoId) return false
        const turnoIdStr = String(turnoId)
        const turnoIdNum = Number(turnoId)

        // Buscar el turno en shiftMap para obtener su código (text)
        let shiftInfo = this.shiftMap[turnoIdStr]
        if (!shiftInfo && !isNaN(turnoIdNum)) {
          shiftInfo = this.shiftMap[turnoIdNum]
        }

        if (!shiftInfo || !shiftInfo.text) return false

        // El campo text contiene el nombre completo, ej: "DF DIA FAMILIA"
        // Verificar si contiene alguno de los códigos de turnosNoVisibles
        const textoTurno = (shiftInfo.text || '').trim().toUpperCase()

        // Verificar si el texto del turno contiene alguno de los códigos no visibles
        // El código generalmente aparece al inicio del texto (ej: "DF DIA FAMILIA" contiene "DF")
        return this.turnosNoVisibles.some(codigo => {
          const codigoUpper = codigo.trim().toUpperCase()
          if (!codigoUpper) return false

          // Verificar si el código aparece al inicio del texto seguido de espacio
          // o es exactamente igual al texto completo
          // Ej: "DF" coincide con "DF DIA FAMILIA" o "DF"
          return textoTurno === codigoUpper || textoTurno.startsWith(codigoUpper + ' ')
        })
      },
      obtenerOpcionesTurnosParaDia (dia) {
        // Obtener opciones de turnos filtradas para un día específico
        // Excluir turnos no visibles, pero incluir el turno actual del día si está asignado
        const turnoActualId = dia && dia.turnoId ? String(dia.turnoId) : null
        const esTurnoActualNoVisible = turnoActualId && this.esTurnoNoVisible(turnoActualId)

        return this.shiftsOptions.filter(option => {
          // Si es el turno actual y está en la lista de no visibles, incluirlo
          if (option.value === turnoActualId && esTurnoActualNoVisible) {
            return true
          }

          // Para los demás turnos, excluir los que están en la lista de no visibles
          return !this.esTurnoNoVisible(option.value)
        })
      },
      puedeEditarProg (dia) {
        // Si no hay turno asignado, se puede editar
        if (!dia || !dia.turnoId) {
          return true
        }

        // No se puede editar si el turno está en la lista de no visibles
        if (this.esTurnoNoVisible(dia.turnoId)) {
          return false
        }

        // No se puede editar si tiene incapacidad
        if (this.tieneIncapacidad(dia)) {
          return false
        }

        // Se puede editar si:
        // 1. Es universal, O
        // 2. No está en la lista de no visibles (ya verificamos arriba que no está)
        // Esto permite editar turnos normales que no están en la lista de no visibles
        return true
      },
      esTurnoDeshabilitado (dia, turnoId) {
        // Un turno está deshabilitado si está en la lista de no visibles
        // y es el turno actual del día (no se puede cambiar)
        if (!turnoId || !dia) return false
        const turnoIdStr = String(turnoId)
        const turnoActualId = dia.turnoId ? String(dia.turnoId) : null

        // Solo deshabilitar si es el turno actual y está en la lista de no visibles
        return turnoIdStr === turnoActualId && this.esTurnoNoVisible(turnoIdStr)
      },
      onTurnoChange (dia) {
        // Asegurar que el shiftMap tenga la información del turno seleccionado
        if (dia.turnoId) {
          const turnoIdStr = String(dia.turnoId)
          const turnoIdNum = Number(dia.turnoId)
          let shiftInfo = this.shiftMap[turnoIdStr]

          // Si no existe con string, intentar con número
          if (!shiftInfo && !isNaN(turnoIdNum)) {
            shiftInfo = this.shiftMap[turnoIdNum]
          }

          // Si no existe en shiftMap, intentar encontrarlo en shiftsOptions
          if (!shiftInfo) {
            const option = this.shiftsOptions.find(opt => opt.value === turnoIdStr)
            if (option) {
              // Buscar el turno original en los datos cargados
              // Esto asegura que shiftMap tenga la información correcta
              this.$forceUpdate()
            }
          } else {
            // Si el turno tiene start_time y end_time, llenar los campos (incluye turnos universales)
            if (shiftInfo.start_time && shiftInfo.end_time) {
              // Formatear start_time y end_time a formato HH:mm si vienen en otro formato
              let startTime = shiftInfo.start_time
              let endTime = shiftInfo.end_time

              // Si vienen en formato "HH:mm:ss" o "YYYY-MM-DD HH:mm:ss", extraer solo HH:mm
              if (startTime.includes(' ')) {
                const timePart = startTime.split(' ')[1]
                if (timePart) {
                  startTime = timePart.substring(0, 5) // Obtiene HH:MM
                }
              }
              if (endTime.includes(' ')) {
                const timePart = endTime.split(' ')[1]
                if (timePart) {
                  endTime = timePart.substring(0, 5) // Obtiene HH:MM
                }
              }

              // Convertir "24:00" a "00:00" para compatibilidad con inputs de tipo time
              // Los inputs HTML time no aceptan "24:00", solo "00:00" a "23:59"
              if (endTime === '24:00') {
                endTime = '00:00'
              }

              // Asignar los valores a los campos de programación
              dia.progEntrada = startTime
              dia.progSalida = endTime
            }
          }
        }

        // Forzar actualización de la vista cuando cambia el turno
        this.$forceUpdate()
      },
      onTurnoPartidoChange (dia) {
        // Si se desactiva el turno partido, limpiar los campos
        if (!dia.usarTurnoPartido) {
          dia.progEntradaPartido = ''
          dia.progSalidaPartido = ''
        }
        this.$forceUpdate()
      },
      procesarMarcacionIndividual (m) {
        // Extrae y formatea una marcación individual del backend
        let entrada = ''
        let salida = ''
        let entradaDateTime = null
        let salidaDateTime = null

        if (m.fecha_hora_inicio) {
          try {
            entradaDateTime = moment(m.fecha_hora_inicio)
            entrada = entradaDateTime.format('HH:mm')
          } catch (e) {
            const str = String(m.fecha_hora_inicio)
            if (str.length >= 16) {
              entrada = str.substring(11, 16)
            } else if (str.includes(':')) {
              entrada = str.substring(0, 5)
            }
          }
        }

        if (m.fecha_hora_fin) {
          try {
            salidaDateTime = moment(m.fecha_hora_fin)
            salida = salidaDateTime.format('HH:mm')
          } catch (e) {
            const str = String(m.fecha_hora_fin)
            if (str.length >= 16) {
              salida = str.substring(11, 16)
            } else if (str.includes(':')) {
              salida = str.substring(0, 5)
            }
          }
        }

        if (entrada || salida) {
          return {
            entrada: entrada,
            salida: salida,
            entradaDateTime: entradaDateTime,
            salidaDateTime: salidaDateTime
          }
        }
        return null
      },
      async cargarMarcacionesRealesDia (dia) {
        // Carga todas las marcaciones reales de un día específico
        // Este método se mantiene para compatibilidad y como fallback
        if (!this.empleadoMarcacionesSeleccionado || !dia.fecha) {
          return
        }

        try {
          const {data} = await this.http.getInstance().get(
            `weekly_schedule/employee/${this.empleadoMarcacionesSeleccionado}/real_marks`,
            {params: {date: dia.fecha}}
          )
          const all = (data && data.data) || []

          // Procesar todas las marcaciones y agregarlas al array
          const marcaciones = []
          all.forEach(m => {
            const marcacion = this.procesarMarcacionIndividual(m)
            if (marcacion) {
              marcaciones.push(marcacion)
            }
          })

          // Actualizar el día con todas las marcaciones
          const diaIndex = this.semanaMarcaciones.findIndex(d => d.fecha === dia.fecha)
          if (diaIndex !== -1) {
            // Asegurar que siempre haya al menos una casilla vacía si no hay marcaciones
            if (marcaciones.length === 0) {
              this.semanaMarcaciones[diaIndex].realMarcaciones = [{
                entrada: '',
                salida: '',
                entradaDateTime: null,
                salidaDateTime: null
              }]
            } else {
              this.semanaMarcaciones[diaIndex].realMarcaciones = marcaciones
            }

            // Mantener la primera marcación como realEntrada y realSalida para compatibilidad
            if (marcaciones.length > 0) {
              const primera = marcaciones[0]
              this.semanaMarcaciones[diaIndex].realEntrada = primera.entrada
              this.semanaMarcaciones[diaIndex].realSalida = primera.salida
              this.semanaMarcaciones[diaIndex].realEntradaDateTime = primera.entradaDateTime
              this.semanaMarcaciones[diaIndex].realSalidaDateTime = primera.salidaDateTime
            } else {
              // Limpiar campos si no hay marcaciones
              this.semanaMarcaciones[diaIndex].realEntrada = ''
              this.semanaMarcaciones[diaIndex].realSalida = ''
              this.semanaMarcaciones[diaIndex].realEntradaDateTime = null
              this.semanaMarcaciones[diaIndex].realSalidaDateTime = null
            }
          }
        } catch (e) {
          console.error('Error fetching real marks:', e)
          // No mostrar error al usuario, solo loguear
        }
      },
      formatDateTime (v) {
        return v ? moment(v).format('YYYY-MM-DD HH:mm') : ''
      },
      async cargarMarcacionesRealesSemana () {
        // Carga todas las marcaciones reales de la semana completa en una sola petición
        if (!this.empleadoMarcacionesSeleccionado || !this.fechaSemanaMarcaciones) {
          return
        }

        try {
          const weekStart = this.getWeekStartDate(this.fechaSemanaMarcaciones)
          const weekEnd = this.getWeekEndDate(this.fechaSemanaMarcaciones)

          // Intentar obtener todas las marcaciones de la semana en una sola petición
          // Si el endpoint no soporta rango de fechas, intentará con week_start y week_end
          const {data} = await this.http.getInstance().get(
            `weekly_schedule/employee/${this.empleadoMarcacionesSeleccionado}/real_marks`,
            {
              params: {
                week_start: weekStart,
                week_end: weekEnd
              }
            }
          )

          const all = (data && data.data) || []

          // Agrupar marcaciones por fecha
          const marcacionesPorFecha = {}

          all.forEach(m => {
            // Extraer la fecha de la marcación
            let fecha = null
            if (m.fecha) {
              fecha = m.fecha
            } else if (m.fecha_hora_inicio) {
              try {
                fecha = moment(m.fecha_hora_inicio).format('YYYY-MM-DD')
              } catch (e) {
                const str = String(m.fecha_hora_inicio)
                if (str.length >= 10) {
                  fecha = str.substring(0, 10)
                }
              }
            }

            if (!fecha) return

            // Inicializar array para esta fecha si no existe
            if (!marcacionesPorFecha[fecha]) {
              marcacionesPorFecha[fecha] = []
            }

            // Procesar la marcación
            const marcacion = this.procesarMarcacionIndividual(m)
            if (marcacion) {
              marcacionesPorFecha[fecha].push(marcacion)
            }
          })

          // Actualizar cada día de la semana con sus marcaciones
          this.semanaMarcaciones.forEach(dia => {
            const marcaciones = marcacionesPorFecha[dia.fecha] || []
            // Asegurar que siempre haya al menos una casilla vacía si no hay marcaciones
            if (marcaciones.length === 0) {
              dia.realMarcaciones = [{
                entrada: '',
                salida: '',
                entradaDateTime: null,
                salidaDateTime: null
              }]
            } else {
              dia.realMarcaciones = marcaciones
            }

            // Mantener la primera marcación como realEntrada y realSalida para compatibilidad
            if (marcaciones.length > 0) {
              const primera = marcaciones[0]
              dia.realEntrada = primera.entrada
              dia.realSalida = primera.salida
              dia.realEntradaDateTime = primera.entradaDateTime
              dia.realSalidaDateTime = primera.salidaDateTime
            } else {
              // Limpiar campos si no hay marcaciones
              dia.realEntrada = ''
              dia.realSalida = ''
              dia.realEntradaDateTime = null
              dia.realSalidaDateTime = null
            }
          })
        } catch (e) {
          console.error('Error fetching real marks for week:', e)
          // Si falla la petición optimizada, usar el método anterior como fallback
          await this.cargarMarcacionesRealesSemanaFallback()
        }
      },
      async cargarMarcacionesRealesSemanaFallback () {
        // Método fallback: carga las marcaciones día por día (método anterior)
        // Se usa solo si la petición optimizada falla
        await Promise.all(
          this.semanaMarcaciones.map(dia => this.cargarMarcacionesRealesDia(dia))
        )
      },
      async cargarMarcacionesSemana () {
        if (!this.empleadoMarcacionesSeleccionado || !this.fechaSemanaMarcaciones) {
          // Si no hay empleado seleccionado, inicializar semana vacía
          this.inicializarMarcacionesSemana(this.fechaSemanaMarcaciones)
          return
        }

        try {
          this.loading = true
          const {data} = await this.http.getInstance().get(
            `weekly_schedule/employee/${this.empleadoMarcacionesSeleccionado}/weekly`, {
              params: {
                week_start: this.getWeekStartDate(this.fechaSemanaMarcaciones),
                week_end: this.getWeekEndDate(this.fechaSemanaMarcaciones)
              }
            }
          )

          if (data && data.success) {
            this.procesarHorarios(data.data)
            // Cargar todas las marcaciones reales de la semana en una sola petición optimizada
            await this.cargarMarcacionesRealesSemana()
          } else {
            // Si no hay datos, inicializar semana vacía
            this.inicializarMarcacionesSemana(this.fechaSemanaMarcaciones)
          }
        } catch (error) {
          console.error('Error loading schedule:', error)
          // Inicializar semana vacía en caso de error
          this.inicializarMarcacionesSemana(this.fechaSemanaMarcaciones)
          // No mostrar error al usuario si es porque no hay datos
          if (error.response && error.response.status !== 404) {
            Mensajes.error('Error', 'No fue posible cargar la programación semanal.')
          }
        } finally {
          this.loading = false
        }
      },
      async guardarMarcacionesSemana () {
        if (!this.empleadoMarcacionesSeleccionado) {
          this.$message.error('Seleccione un empleado')
          return
        }

        for (const dia of this.semanaMarcaciones) {
          const tieneTurnoYEditable = !!dia.turnoId && (this.puedeEditarProg(dia) || dia.usarTurnoPartido)
          if (!tieneTurnoYEditable) continue
          if (!dia.progEntrada || !dia.progSalida) {
            Mensajes.error('Error', 'Complete la hora de entrada y salida programadas para todos los días con turno asignado.')
            return
          }
          if (dia.usarTurnoPartido && (!dia.progEntradaPartido || !dia.progSalidaPartido)) {
            Mensajes.error('Error', 'Para los días con turno partido, complete la hora de inicio y fin del turno partido.')
            return
          }
        }

        try {
          this.loading = true

          // Obtener la fecha actual para las marcas de tiempo
          // eslint-disable-next-line no-unused-vars
          const now = new Date()

          const schedules = []

          this.semanaMarcaciones.forEach(dia => {
            // Procesar si tiene programación principal (entrada, salida y turno seleccionado)
            const tieneProgramacionPrincipal = !!dia.progEntrada && !!dia.progSalida && !!dia.turnoId
            if (!tieneProgramacionPrincipal) return

            // Verificar si el día es editable (puede modificarse)
            const puedeEditar = this.puedeEditarProg(dia)
            const tieneTurnoPartido = dia.usarTurnoPartido

            // Enviar si:
            // 1. Es editable (puedeEditarProg retorna true), O
            // 2. Tiene turno partido habilitado
            // Esto permite enviar turnos nuevos, turnos existentes editables, y cualquier turno con turno partido
            if (!puedeEditar && !tieneTurnoPartido) return

            // Analizar la fecha para obtener el año, mes y período
            const fecha = new Date(dia.fecha)
            const year = fecha.getFullYear()
            const month = fecha.getMonth() + 1
            const periodCalculated = Math.ceil(fecha.getDate() / 15) // Suponiendo 2 periodos por mes (1-15, 16-fin)
            // Transformación para el backend: periodo 1 -> 2, periodo 2 -> 4
            const period = periodCalculated === 1 ? 2 : periodCalculated === 2 ? 4 : periodCalculated

            // Programación principal
            // Detectar si el turno cruza la medianoche (hora de salida menor que hora de entrada)
            const startDateTime = this.combineDateAndTime(dia.fecha, dia.progEntrada)
            let endDateTime = this.combineDateAndTime(dia.fecha, dia.progSalida)

            // Si la hora de salida es menor o igual que la de entrada, el turno cruza medianoche
            // Ajustar la fecha de salida al día siguiente
            if (dia.progEntrada && dia.progSalida) {
              const [entradaHora, entradaMin] = dia.progEntrada.split(':').map(Number)
              const [salidaHora, salidaMin] = dia.progSalida.split(':').map(Number)
              const entradaMinutos = entradaHora * 60 + entradaMin
              const salidaMinutos = salidaHora * 60 + salidaMin

              if (salidaMinutos <= entradaMinutos) {
                // El turno cruza medianoche, ajustar fecha de salida al día siguiente
                const fechaSiguiente = moment(dia.fecha, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
                endDateTime = this.combineDateAndTime(fechaSiguiente, dia.progSalida)
              }
            }

            const scheduleData = {
              id: dia.id,
              id_emp: this.empleadoMarcacionesSeleccionado,
              start_time: startDateTime,
              final_time: endDateTime,
              work: 'INGRESO',
              comments: dia.notas || '',
              n_hours: null,
              status: dia.status || 'ACT',
              year: year,
              month: month,
              period: period,
              id_rh_t_shifts_setup: dia.turnoId || null,
              usar_turno_partido: dia.usarTurnoPartido || false
            }

            // Si tiene turno partido, agregar los campos de turno partido al mismo registro
            if (dia.usarTurnoPartido && dia.progEntradaPartido && dia.progSalidaPartido) {
              let startDateTimePartido = this.combineDateAndTime(dia.fecha, dia.progEntradaPartido)
              let endDateTimePartido = this.combineDateAndTime(dia.fecha, dia.progSalidaPartido)

              // Detectar si el turno partido cruza la medianoche
              const [entradaPartidoHora, entradaPartidoMin] = dia.progEntradaPartido.split(':').map(Number)
              const [salidaPartidoHora, salidaPartidoMin] = dia.progSalidaPartido.split(':').map(Number)
              const entradaPartidoMinutos = entradaPartidoHora * 60 + entradaPartidoMin
              const salidaPartidoMinutos = salidaPartidoHora * 60 + salidaPartidoMin

              if (salidaPartidoMinutos <= entradaPartidoMinutos) {
                // El turno partido cruza medianoche, ajustar fecha de salida al día siguiente
                const fechaSiguiente = moment(dia.fecha, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
                endDateTimePartido = this.combineDateAndTime(fechaSiguiente, dia.progSalidaPartido)
              }

              scheduleData.start_date_shift_match = startDateTimePartido
              scheduleData.end_date_shift_match = endDateTimePartido
            } else {
              // Si no tiene turno partido pero el registro existe (tiene id), limpiar los campos
              if (dia.id) {
                scheduleData.start_date_shift_match = null
                scheduleData.end_date_shift_match = null
              }
            }

            schedules.push(scheduleData)
          })

          const response = await this.http.getInstance().post(
            'weekly_schedule/batch_update',
            {schedules}
          )

          if (response.data.success) {
            this.$message.success('Horario guardado exitosamente')
            await this.cargarMarcacionesSemana()
          }
        } catch (error) {
          console.error('Error saving schedule:', error)
          this.$message.error('Error al guardar el horario')
        } finally {
          this.loading = false
        }
      },
      onFechaSemanaMarcacionesChange () {
        this.inicializarMarcacionesSemana(this.fechaSemanaMarcaciones)
        // Solo cargar datos si hay un empleado seleccionado
        if (this.empleadoMarcacionesSeleccionado) {
          this.cargarMarcacionesSemana()
        }
      },
      irSemanaAnteriorMarcaciones () {
        if (!this.fechaSemanaMarcaciones) return
        const nueva = moment(this.fechaSemanaMarcaciones, 'YYYY-MM-DD')
          .subtract(7, 'days')
          .format('YYYY-MM-DD')
        this.fechaSemanaMarcaciones = nueva
        this.inicializarMarcacionesSemana(nueva)
        // Solo cargar datos si hay un empleado seleccionado
        if (this.empleadoMarcacionesSeleccionado) {
          this.cargarMarcacionesSemana()
        }
      },
      irSemanaSiguienteMarcaciones () {
        if (!this.fechaSemanaMarcaciones) return
        const nueva = moment(this.fechaSemanaMarcaciones, 'YYYY-MM-DD')
          .add(7, 'days')
          .format('YYYY-MM-DD')
        this.fechaSemanaMarcaciones = nueva
        this.inicializarMarcacionesSemana(nueva)
        // Solo cargar datos si hay un empleado seleccionado
        if (this.empleadoMarcacionesSeleccionado) {
          this.cargarMarcacionesSemana()
        }
      },
      irAResumenHistoricoMarcaciones () {
        Mensajes.info('Información', 'El resumen histórico de marcaciones estará disponible próximamente.')
      },
      parseHoraToMinutos (hora) {
        if (!hora) return null
        const partes = hora.split(':')
        if (partes.length !== 2) return null
        const horas = parseInt(partes[0], 10)
        const minutos = parseInt(partes[1], 10)
        if (isNaN(horas) || isNaN(minutos)) return null
        return (horas * 60) + minutos
      },
      calcularVariacionEntrada (dia) {
        if (dia.tipo === 'descanso') return 0
        const prog = this.parseHoraToMinutos(dia.progEntrada)
        const real = this.parseHoraToMinutos(dia.realEntrada)
        if (prog === null || real === null) return null

        // Si tenemos información de fecha completa, usarla para cálculo más preciso
        if (dia.realEntradaDateTime && dia.fecha) {
          try {
            // Crear fecha/hora programada usando la fecha del día
            const fechaProg = moment(`${dia.fecha} ${dia.progEntrada}`, 'YYYY-MM-DD HH:mm')
            const fechaReal = dia.realEntradaDateTime

            // Calcular diferencia en minutos
            const diffMinutes = fechaReal.diff(fechaProg, 'minutes')
            return diffMinutes
          } catch (e) {
            // Si falla el parsing, continuar con el método simple
          }
        }

        // Método simple: calcular diferencia en minutos
        let diff = real - prog

        // Si la diferencia es muy grande (más de 12 horas), podría ser que:
        // 1. La entrada real es muy tarde (ej: 19:02) y la programada es temprana (ej: 07:00)
        //    En este caso, la entrada real podría ser del día anterior al turno
        // 2. O la entrada real es muy temprana (ej: 06:57) y la programada es tarde (ej: 19:00)
        //    En este caso, la entrada real es del mismo día pero muy temprano

        // Si la diferencia es mayor a 12 horas (720 minutos), ajustar considerando que
        // podría ser del día anterior (sumar 24 horas a la entrada real)
        if (diff > 720) {
          // La entrada real es mucho más tarde que la programada
          // Podría ser del día anterior, así que restamos 24 horas (1440 minutos)
          diff = (real + 1440) - prog
        } else if (diff < -720) {
          // La entrada real es mucho más temprana que la programada
          // Podría ser del día siguiente, así que sumamos 24 horas
          diff = real - (prog + 1440)
        }

        return diff
      },
      calcularVariacionSalida (dia) {
        if (dia.tipo === 'descanso') return 0
        // En turno partido, la variación de salida se calcula contra la última salida programada
        // (progSalidaPartido), no contra la del primer bloque (progSalida)
        const progSalidaRef = (dia.usarTurnoPartido && dia.progSalidaPartido)
          ? dia.progSalidaPartido
          : dia.progSalida
        const prog = this.parseHoraToMinutos(progSalidaRef)
        const real = this.parseHoraToMinutos(dia.realSalida)
        if (prog === null || real === null) return null

        // Si tenemos información de fecha completa, usarla para cálculo más preciso
        if (dia.realSalidaDateTime && dia.fecha) {
          try {
            // Crear fecha/hora programada usando la fecha del día
            // Si la salida cruza medianoche, ajustar al día siguiente
            let fechaProg = moment(`${dia.fecha} ${progSalidaRef}`, 'YYYY-MM-DD HH:mm')
            const fechaReal = dia.realSalidaDateTime

            // Si la salida programada es menor que la entrada, cruza medianoche
            const entradaRef = (dia.usarTurnoPartido && dia.progEntradaPartido) ? dia.progEntradaPartido : dia.progEntrada
            if (entradaRef && progSalidaRef) {
              const entradaMin = this.parseHoraToMinutos(entradaRef)
              const salidaMin = this.parseHoraToMinutos(progSalidaRef)
              if (salidaMin <= entradaMin) {
                fechaProg = fechaProg.add(1, 'days')
              }
            }

            // Calcular diferencia en minutos
            const diffMinutes = fechaReal.diff(fechaProg, 'minutes')
            return diffMinutes
          } catch (e) {
            // Si falla el parsing, continuar con el método simple
          }
        }

        // Método simple: calcular diferencia en minutos
        let diff = real - prog

        // Si la diferencia es muy grande (más de 12 horas), ajustar
        if (diff > 720) {
          diff = (real + 1440) - prog
        } else if (diff < -720) {
          diff = real - (prog + 1440)
        }

        return diff
      },
      obtenerClaseVariacionEntrada (dia) {
        if (dia.tipo === 'descanso') {
          return 'pill-on-time-marcaciones'
        }
        const diff = this.calcularVariacionEntrada(dia)
        if (diff === null) {
          return 'pill-on-time-marcaciones'
        }
        const absDiff = Math.abs(diff)
        if (absDiff <= this.tolerancia) {
          return 'pill-on-time-marcaciones'
        }
        if (diff > 0) {
          return 'pill-late-marcaciones'
        }
        return 'pill-early-marcaciones'
      },
      obtenerTextoVariacionEntrada (dia) {
        if (dia.tipo === 'descanso') {
          return 'Descanso'
        }

        // Si hay entrada real pero no programada, mostrar información
        if (dia.realEntrada && !dia.progEntrada) {
          return 'Sin horario programado'
        }

        // Si hay entrada programada pero no real, mostrar información
        if (dia.progEntrada && !dia.realEntrada) {
          return 'Sin marcación de entrada'
        }

        // Si no hay ninguna, mostrar sin datos
        if (!dia.realEntrada && !dia.progEntrada) {
          return 'Sin datos'
        }

        const diffEntrada = this.calcularVariacionEntrada(dia)
        const diffSalida = this.calcularVariacionSalida(dia)

        if (diffEntrada === null && diffSalida === null) {
          return 'Sin datos'
        }

        let textoEntrada = ''
        let textoSalida = ''

        // Procesar variación de entrada
        if (diffEntrada !== null) {
          const absDiffEntrada = Math.abs(diffEntrada)
          if (absDiffEntrada <= this.tolerancia) {
            textoEntrada = `Ent: ${diffEntrada >= 0 ? '+' : '-'}${absDiffEntrada} min`
          } else if (diffEntrada > 0) {
            textoEntrada = `Ent: +${absDiffEntrada} min tarde`
          } else {
            textoEntrada = `Ent: -${absDiffEntrada} min (temprano)`
          }
        }

        // Procesar variación de salida
        if (diffSalida !== null) {
          const absDiffSalida = Math.abs(diffSalida)
          if (absDiffSalida <= this.tolerancia) {
            textoSalida = `Sal: ${diffSalida >= 0 ? '+' : '-'}${absDiffSalida} min`
          } else if (diffSalida > 0) {
            textoSalida = `Sal: +${absDiffSalida} min tarde`
          } else {
            textoSalida = `Sal: -${absDiffSalida} min (temprano)`
          }
        }

        // Combinar ambos textos
        if (textoEntrada && textoSalida) {
          return `${textoEntrada} | ${textoSalida}`
        } else if (textoEntrada) {
          return textoEntrada
        } else if (textoSalida) {
          return textoSalida
        }

        return 'Sin datos'
      },
      calcularMinutosProgramadosDia (dia) {
        if (dia.tipo === 'descanso') return 0

        let totalMinutos = 0

        // Calcular minutos de la programación principal
        const entrada = this.parseHoraToMinutos(dia.progEntrada)
        const salida = this.parseHoraToMinutos(dia.progSalida)
        if (entrada !== null && salida !== null) {
          // Si la salida es menor o igual a la entrada, el turno cruza la medianoche
          // Agregar 24 horas (1440 minutos) a la salida
          if (salida <= entrada) {
            totalMinutos += (salida + 1440) - entrada
          } else {
            totalMinutos += salida - entrada
          }
        }

        // Si tiene turno partido, agregar esos minutos también
        if (dia.usarTurnoPartido) {
          const entradaPartido = this.parseHoraToMinutos(dia.progEntradaPartido)
          const salidaPartido = this.parseHoraToMinutos(dia.progSalidaPartido)
          if (entradaPartido !== null && salidaPartido !== null) {
            if (salidaPartido <= entradaPartido) {
              totalMinutos += (salidaPartido + 1440) - entradaPartido
            } else {
              totalMinutos += salidaPartido - entradaPartido
            }
          }
        }

        return totalMinutos
      },
      calcularMinutosTrabajadosDia (dia) {
        if (dia.tipo === 'descanso') return 0

        // Si tenemos información de fecha completa, usarla para cálculo más preciso
        if (dia.realEntradaDateTime && dia.realSalidaDateTime) {
          try {
            // Calcular diferencia en minutos usando las fechas completas
            const diffMinutes = dia.realSalidaDateTime.diff(dia.realEntradaDateTime, 'minutes')
            // Si la diferencia es negativa, significa que cruza la medianoche
            // En este caso, las fechas ya deberían estar correctas del backend
            return diffMinutes > 0 ? diffMinutes : 0
          } catch (e) {
            // Si falla el parsing, continuar con el método simple
          }
        }

        // Método simple: usar solo las horas
        const entrada = this.parseHoraToMinutos(dia.realEntrada)
        const salida = this.parseHoraToMinutos(dia.realSalida)
        if (entrada === null || salida === null) return 0

        // Si la salida es menor o igual a la entrada, el turno cruza la medianoche
        // Agregar 24 horas (1440 minutos) a la salida
        if (salida <= entrada) {
          return (salida + 1440) - entrada
        }
        return salida - entrada
      },
      formatearHorasConComa (valorHoras) {
        const valor = isNaN(valorHoras) ? 0 : valorHoras
        const redondeado = Math.round(valor * 10) / 10
        const texto = redondeado.toFixed(1).replace('.', ',')
        return `${texto}`
      },
      obtenerTextoHorasLaboradasDia (dia) {
        if (dia.tipo === 'descanso') {
          return '0,0/0,0 (descanso)'
        }

        // Usar horas_trabajadas_dia del backend si está disponible
        const horasTrabajadas = dia.horasTrabajadasDia ? parseFloat(dia.horasTrabajadasDia) || 0 : 0

        // Calcular horas programadas (prog salida - prog entrada, considerando turnos partidos)
        const minProg = this.calcularMinutosProgramadosDia(dia)
        const horasProgramadas = minProg / 60

        const textoHorasTrabajadas = this.formatearHorasConComa(horasTrabajadas)
        const textoHorasProgramadas = this.formatearHorasConComa(horasProgramadas)

        // Formato: Horas Laboradas / horas programadas
        return `${textoHorasTrabajadas}/${textoHorasProgramadas}`
      },
      async exportarMarcacionesExcel () {
        if (!this.empleadoMarcacionesSeleccionado) {
          Mensajes.warning('Advertencia', 'Seleccione un empleado.')
          return
        }
        try {
          this.loading = true
          const weekStart = this.getWeekStartDate(this.fechaSemanaMarcaciones)
          const weekEnd = this.getWeekEndDate(this.fechaSemanaMarcaciones)

          const response = await this.http.getInstance().get(
            'programacion_semana/downloadExcel',
            {
              params: {
                id_emp: String(this.empleadoMarcacionesSeleccionado),
                week_start: weekStart,
                week_end: weekEnd
              },
              responseType: 'blob'
            }
          )

          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url

          const contentDisposition = response.headers['content-disposition']
          let filename = `programacion_semanal_${this.empleadoMarcacionesSeleccionado}_${weekStart}_${weekEnd}.xlsx`
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i)
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1]
            }
          }

          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)

          Mensajes.success('Correcto', 'Archivo Excel descargado exitosamente.')
        } catch (error) {
          console.error('Error exporting Excel:', error)
          const errorMessage = this.$getErrorMessage ? this.$getErrorMessage(error, 'No fue posible exportar el archivo Excel.') : 'No fue posible exportar el archivo Excel.'
          Mensajes.error('Error', errorMessage)
        } finally {
          this.loading = false

          if (this.empleadoMarcacionesSeleccionado && this.fechaSemanaMarcaciones) {
            this.cargarMarcacionesSemana()
          }
        }
      },
      async eliminarTurno (dia) {
        if (!dia.id) {
          this.$message.warning('No hay turno programado para eliminar')
          return
        }

        this.$confirm({
          title: 'Confirmar eliminación',
          content: `¿Está seguro que desea eliminar el turno del ${dia.nombre} ${dia.etiquetaFecha}?`,
          okText: 'Sí, eliminar',
          okType: 'danger',
          cancelText: 'Cancelar',
          onOk: async () => {
            try {
              this.$set(dia, 'eliminando', true)
              const response = await this.http.getInstance().delete(
                `weekly_schedule/${dia.id}`
              )

              if (response.data && response.data.success !== false) {
                this.$message.success('Turno eliminado exitosamente')
                // Limpiar los datos del día
                dia.id = null
                dia.turnoId = null
                dia.progEntrada = ''
                dia.progSalida = ''
                dia.usarTurnoPartido = false
                dia.progEntradaPartido = ''
                dia.progSalidaPartido = ''
                dia.notas = ''
                dia.status = 'LIQ'
                dia.seleccionadoEliminar = false
                // Recargar los datos de la semana
                await this.cargarMarcacionesSemana()
              } else {
                throw new Error(response.data.message || 'Error al eliminar el turno')
              }
            } catch (error) {
              console.error('Error deleting shift:', error)
              const errorMessage = this.$getErrorMessage ? this.$getErrorMessage(error, 'No fue posible eliminar el turno.') : 'No fue posible eliminar el turno.'
              this.$message.error(errorMessage)
            } finally {
              this.$set(dia, 'eliminando', false)
            }
          }
        })
      }
    }
  }
</script>

<style>
  .programacion-semanas-wrapper .ant-spin-container {
    position: relative !important;
  }

  .programacion-semanas-wrapper .ant-spin-nested-loading {
    position: relative !important;
  }

  .programacion-semanas-wrapper .ant-spin {
    position: relative !important;
  }
</style>

<style scoped>
  .header-marcaciones {
    margin-top: -30px; /* antes seguramente era 24px o más */
    margin-bottom: 16px;
  }

  .titulo-marcaciones {
    margin: 0;
    line-height: 1.3;
  }

  .spin-content {
    padding: 0;
  }

  .ant-table-small {
    font-size: 12px;
  }

  .ant-form-item {
    margin-bottom: 8px;
  }

  h2 {
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
  }

  .horario-cell {
    padding: 4px;
  }

  .turno-row {
    margin-bottom: 8px;
  }

  .turno-row:last-child {
    margin-bottom: 0;
  }

  .horario-cell >>> .ant-time-picker {
    width: 100%;
  }

  .marcaciones-app-container {
    margin-top: 0;
    padding: 20px;
  }

  .header-row-marcaciones {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
  }

  .header-left-marcaciones {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    align-items: flex-end;
  }

  .filters-marcaciones {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;
  }

  .empleado-field-marcaciones select {
    min-width: 260px;
  }

  .field-group-marcaciones {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .header-actions-marcaciones {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }

  .main-actions-marcaciones {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
  }

  .field-label-marcaciones {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6b7280;
  }

  .field-group-marcaciones select,
  .field-group-marcaciones input[type="date"] {
    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 14px;
    outline: none;
    background: #f9fafb;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  }

  .field-group-marcaciones select:focus,
  .field-group-marcaciones input[type="date"]:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.08);
    background: #ffffff;
  }

  .week-nav-marcaciones {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
  }

  .btn-marcaciones {
    border-radius: 999px;
    border: 1px solid transparent;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: #e5e7eb;
    color: #111827;
    transition: background 0.18s, transform 0.08s, box-shadow 0.18s, border-color 0.18s;
    white-space: nowrap;
  }

  .btn-marcaciones .icon-marcaciones {
    font-size: 14px;
  }

  .btn-marcaciones:hover {
    background: #d1d5db;
    transform: translateY(-1px);
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
  }

  .btn-outline-marcaciones {
    background: #ffffff;
    border-color: #d1d5db;
  }

  .btn-primary-marcaciones {
    background: #2563eb;
    color: #ffffff;
    border-color: #2563eb;
  }

  .btn-primary-marcaciones:hover {
    background: #1d4ed8;
    border-color: #1d4ed8;
  }

  .btn-ghost-marcaciones {
    background: transparent;
    border-color: transparent;
    color: #6b7280;
  }

  .btn-ghost-marcaciones:hover {
    background: #f3f4f6;
    color: #111827;
  }

  .table-wrapper-marcaciones {
    margin-top: 8px;
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    overflow: hidden;
    background: #ffffff;
  }

  .table-wrapper-marcaciones table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  .table-wrapper-marcaciones thead {
    background: #f3f4ff;
  }

  .table-wrapper-marcaciones th,
  .table-wrapper-marcaciones td {
    padding: 8px 10px;
    text-align: left;
    border-bottom: 1px solid #e5e7eb;
    vertical-align: middle;
  }

  .table-wrapper-marcaciones th:nth-child(3),
  .table-wrapper-marcaciones td:nth-child(3) {
    text-align: center;
  }

  .table-wrapper-marcaciones td.notes-cell-marcaciones {
    min-width: 200px;
    max-width: 290px;
  }

  .table-wrapper-marcaciones th {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #6b7280;
    font-weight: 600;
    background: linear-gradient(90deg, #eef2ff, #eff6ff);
    white-space: nowrap;
  }

  .table-wrapper-marcaciones tbody tr:nth-child(odd) {
    background: #fcfcff;
  }

  .table-wrapper-marcaciones tbody tr:hover {
    background: #eef2ff;
  }

  .day-name-marcaciones {
    font-weight: 600;
    color: #111827;
  }

  .day-sub-marcaciones {
    font-size: 11px;
    color: #9ca3af;
  }

  .pill-marcaciones {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 8px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 500;
    border: 1px solid transparent;
  }

  .pill-on-time-marcaciones {
    background: #ecfdf3;
    color: #166534;
    border-color: #bbf7d0;
  }

  .pill-late-marcaciones {
    background: #fef2f2;
    color: #b91c1c;
    border-color: #fecaca;
  }

  .pill-early-marcaciones {
    background: #eff6ff;
    color: #1d4ed8;
    border-color: #bfdbfe;
  }

  .pill-dot-marcaciones {
    width: 7px;
    height: 7px;
    border-radius: 999px;
  }

  .pill-on-time-marcaciones .pill-dot-marcaciones {
    background: #16a34a;
  }

  .pill-late-marcaciones .pill-dot-marcaciones {
    background: #ef4444;
  }

  .pill-early-marcaciones .pill-dot-marcaciones {
    background: #3b82f6;
  }

  .input-time-marcaciones {
    width: 100%;
    padding: 5px 7px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    font-size: 12px;
    outline: none;
    background: #f9fafb;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  }

  .input-time-marcaciones:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.08);
    background: #ffffff;
  }

  /* Estilo para campos habilitados (activos) */
  .input-enabled-marcaciones {
    background: #ffffff !important;
    border-color: #d1d5db;
  }

  .input-enabled-marcaciones:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.08);
  }

  /* Estilos para textarea de notas */
  .textarea-notes-marcaciones {
    width: 100%;
    min-height: 32px;
  }

  .textarea-notes-marcaciones >>> .ant-input {
    border-radius: 8px;
    border: 1px solid #d1d5db;
    font-size: 12px;
    transition: border-color 0.2s, box-shadow 0.2s;
  }

  .textarea-notes-marcaciones >>> .ant-input:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.08);
  }

  .metric-hours-marcaciones {
    font-weight: 600;
    color: #111827;
    white-space: nowrap;
  }

  .metric-hours-marcaciones span {
    font-size: 10px;
    color: #6b7280;
    font-weight: 400;
    margin-left: 2px;
  }

  .kpi-bar-marcaciones {
    margin-top: 18px;
    padding: 12px 14px;
    border-radius: 12px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .kpi-group-marcaciones {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
  }

  .kpi-item-marcaciones {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 140px;
  }

  .kpi-label-marcaciones {
    font-size: 11px;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  .kpi-value-marcaciones {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
  }

  .kpi-tag-marcaciones {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .kpi-tag-ok-marcaciones {
    background: #ecfdf3;
    color: #166534;
  }

  .kpi-tag-risk-marcaciones {
    background: #fff7ed;
    color: #9a3412;
  }

  .kpi-tag-marcaciones .dot-marcaciones {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: currentColor;
  }

  .progress-wrapper-marcaciones {
    flex: 1;
    min-width: 220px;
  }

  .progress-label-marcaciones {
    font-size: 11px;
    color: #6b7280;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
  }

  .progress-bar-marcaciones {
    width: 100%;
    height: 10px;
    border-radius: 999px;
    background: #e5e7eb;
    overflow: hidden;
    position: relative;
  }

  .progress-fill-marcaciones {
    height: 100%;
    background: linear-gradient(90deg, #2563eb, #22c55e);
  }

  .progress-marker-marcaciones {
    position: absolute;
    top: -3px;
    left: calc(100% - 2px);
    width: 2px;
    height: 16px;
    background: #9ca3af;
  }

  .progress-marker-label-marcaciones {
    font-size: 10px;
    color: #6b7280;
    margin-top: 2px;
    text-align: right;
  }

  .footer-actions-marcaciones {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 18px;
    gap: 12px;
    flex-wrap: wrap;
  }

  .legend-marcaciones {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 11px;
    color: #6b7280;
    align-items: center;
  }

  .legend-title-marcaciones {
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    font-size: 10px;
  }

  .legend-item-marcaciones {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 8px;
    border-radius: 999px;
    background: #f3f4f6;
  }

  .status-dot-marcaciones {
    width: 8px;
    height: 8px;
    border-radius: 999px;
  }

  .status-on-time-marcaciones {
    background: #16a34a;
  }

  .status-late-marcaciones {
    background: #ef4444;
  }

  .status-early-marcaciones {
    background: #3b82f6;
  }

  .programacion-blocks-marcaciones {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .programacion-block-marcaciones {
    display: flex;
    flex-direction: column;
  }

  .programacion-partido-marcaciones {
    margin-top: 4px;
    padding-top: 6px;
    border-top: 1px dashed #d1d5db;
  }

  .programacion-partido-marcaciones input {
    border-color: #9ca3af;
    background: #f3f4f6;
  }

  .programacion-partido-marcaciones input:focus {
    border-color: #2563eb;
    background: #ffffff;
  }

  .real-marcaciones-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .real-marcacion-item {
    display: flex;
    flex-direction: column;
  }

  .employee-info-marcaciones {
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 12px 16px;
    background: #f9fafb;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
    align-items: center;
  }

  .employee-info-item-marcaciones {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .employee-info-label-marcaciones {
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .employee-info-value-marcaciones {
    font-size: 14px;
    font-weight: 500;
    color: #111827;
  }

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ShiftsManagement/ProgramacionSemanas.vue